import type { SweepCondition } from '../../../types/SweepCondition';

export function clearFirstConditionIfEmpty<T extends SweepCondition>(_sweepCondition: T) {
  if (_sweepCondition.criteria.length === 1) {
    const tempCondition = _sweepCondition.criteria[0];
    if (tempCondition._fieldIds.length === 0) {
      return { ..._sweepCondition, criteria: [], criteriaLogic: '' };
    }
  }
  return { ..._sweepCondition };
}
